var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSalesloft = props => {
  const _uid = React.useId().replace(/:/g, '');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 180,
    fill: "none",
    viewBox: "0 0 180 180"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#" + _uid + "salesloft_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B3D334",
    d: "M111.379 128.812c0-4.266 3.317-7.938 7.938-7.938 4.739 0 8.056 3.672 8.056 7.938s-3.317 7.938-7.938 7.938c-4.739 0-8.056-3.672-8.056-7.938"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#05472C",
    d: "M68.478 61.407c0-6.369 6.013-11.457 13.725-11.457 10.066 0 15.968 4.706 19.367 28.759h2.091l3.137-32.811c-22.222-7.843-50.066.262-50.458 23.922 0 25.491 40.599 25.477 40.599 48.758 0 6.798-6.013 11.504-12.81 11.504-17.921 0-22.169-15.034-23.083-30.72h-2.223l-5.882 29.544s13.334 7.844 27.714 7.844c17.256-.261 28.759-12.941 29.02-26.275 0-25.622-41.197-30.897-41.197-49.068"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _uid + "salesloft_svg__a"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.25 43H137v93.75H43.25z"
  })))));
};
export { SvgSalesloft as ReactComponent };
export default __webpack_public_path__ + "13cb73bcd0b3d3011ca3aa287b6bdea0.svg";